module.exports = __webpack_public_path__ + "static/media/YM79_5.328a4d19.jpg";